<template>
  <div>
    <v-card>
      <ConfirmMarkDialog
        :state="confirmMarkDialog"
        :importedDocuments="importedDocuments"
        @closeDialog="closeConfirmDialog"
        @updateResult="onUpdateResultDocument"
        ref="markDialog"
      />
      <div class="pa-6">
        <div class="full-width text-end">
          <v-menu open-on-hover bottom offset-y v-if="!isPastEndDate">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-0 mb-6" color="green" dark v-bind="attrs" v-on="on" outlined> Nhập/xuất Excel </v-btn>
            </template>

            <v-list>
              <v-list-item class="cursor-pointer">
                <v-list-item-title @click="onUploadClick">Tải lên tệp Excel chứa điểm</v-list-item-title>
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-list-item>
              <v-list-item class="cursor-pointer">
                <v-list-item-title @click="exportDataToExcel">Tải xuống tệp Excel mẫu</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex justify-between align-center pb-6" style="width: 100%">
          <p v-if="isPastEndDate" class="ma-0">
            <span style="color: red">
              <strong
                ><i>Hạn cuối để chấm điểm thi là {{ roomSubject.endDate | getDate }}</i></strong
              >
            </span>
          </p>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveMarks" :loading="loading" :disabled="isPastEndDate">Lưu</v-btn>
        </div>

        <v-card outlined>
          <v-data-table
            item-key="id"
            :headers="headers"
            :loading="loading"
            :items="marks"
            :items-per-page="-1"
            :disable-sort="$vuetify.breakpoint.smAndDown"
            hide-default-footer
            v-bind="this.$attrs"
            fixed-header
          >
            <template v-slot:[`item.examCode`]="{ item }">
              {{ item.examCode || '-' }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              <div v-if="isPastEndDate">
                {{ item.value }}
              </div>
              <v-text-field v-else hide-details outlined dense v-model="item.value" />
            </template>
          </v-data-table>
        </v-card>
        <div class="d-flex justify-end align-center pt-6">
          <v-btn color="primary" @click="saveMarks" :loading="loading" :disabled="isPastEndDate">Lưu</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ExamMark } from '@/plugins/api'
import readXlsxFile from 'read-excel-file'
import ConfirmMarkDialog from './ConfirmMarkDialog.vue'
import moment from 'moment'
import * as XLSX from 'xlsx'

const originHeaders = [
  {
    text: 'Mã phách',
    value: 'testCode',
    align: 'left',
    sortable: false,
    show: true,
    width: '50%'
  },
  {
    text: 'Điểm',
    value: 'value',
    align: 'left',
    sortable: false,
    show: false,
    width: '50%'
  }
]
const schema = {
  id: {
    prop: 'id',
    type: String,
    required: true
  },
  'Mã phách': {
    prop: 'testCode',
    type: String
  },
  'Điểm thi': {
    prop: 'value',
    type: String
  }
}
export default {
  props: {
    query: Object,
    roomSubject: Object
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      marks: [],
      item: {},
      importedDocuments: [],
      confirmMarkDialog: false,
      json_fields: {
        id: 'id',
        'Mã phách': 'testCode',
        'Điểm thi': 'value'
      }
    }
  },
  computed: {
    isPastEndDate() {
      if (!this.roomSubject || !this.roomSubject.endDate) {
        return false
      }

      const currentDate = new Date()
      const endDate = new Date(this.roomSubject.endDate)
      return currentDate > endDate
    }
  },
  methods: {
    ...mapActions('examMark', ['fetchMarks', 'countMarks']),
    async refresh() {
      this.$loading.active = true
      this.loading = true
      try {
        const fetchedMarks = await this.fetchMarks({
          ...this.query,
          status: 'present',
          _sort: 'testCode:ASC'
        })
        this.marks = fetchedMarks
      } catch (error) {
        this.$alert.error('Lỗi load thông tin học sinh')
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    async saveMarks() {
      this.$loading.active = true
      this.loading = true
      try {
        await ExamMark.updateGrades({ marks: this.marks, endDate: this.roomSubject.endDate })
        this.$alert.success('Nhập điểm thành công')
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.loading = false
        this.$loading.active = false
        this.refresh()
      }
    },
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmMarkDialog = true
      }
      this.$loading.active = false
    },
    formatDataForExport(data) {
      return data.map(item => {
        let formattedItem = {}
        for (let key in this.json_fields) {
          const fieldInfo = this.json_fields[key]
          let value = item

          if (typeof fieldInfo === 'string') {
            const pathParts = fieldInfo.split('.')
            pathParts.forEach(part => {
              if (value) {
                value = value[part]
              }
            })
          } else if (typeof fieldInfo === 'object') {
            value = item[fieldInfo.field]
            if (fieldInfo.callback) {
              value = fieldInfo.callback(value)
            }
          }

          formattedItem[key] = value || ''

          if (key === 'Số báo danh' && value) {
            formattedItem[key] = { v: value, t: 's' }
          }
        }
        return formattedItem
      })
    },
    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      const updateData = {
        marks: data,
        endDate: this.roomSubject.endDate
      }
      await ExamMark.updateGrades(updateData)
      this.closeConfirmDialog()
      this.refresh()
    },
    closeConfirmDialog() {
      this.confirmMarkDialog = false
      this.$refs.uploader.value = null
    },
    exportDataToExcel() {
      const formattedData = this.formatDataForExport(this.marks)
      const worksheet = XLSX.utils.json_to_sheet(formattedData)

      this.setColumnWidths(worksheet, formattedData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Marks')

      XLSX.writeFile(workbook, 'diem-thi-hoc-sinh-mau.xlsx')
      this.$loading.active = false
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })

      worksheet['!cols'] = maxWidths.map((width, index) => {
        if (columnNames[index] === 'id') {
          return { width, hidden: true }
        }
        return { width }
      })
    }
  },
  watch: {
    query: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refresh()
        }
      }
    }
  },
  filters: {
    getDate: item => {
      if (item) return moment(item).format('DD/MM/YYYY')
      return ''
    }
  },
  components: { ConfirmMarkDialog }
}
</script>
